import React from 'react';

type RegimePillProps = {
  label: string;
  className?: string;
};

const getRegimeStyle = (label: string) => {
  const normalized = label.toLowerCase();
  if (normalized.includes('squeeze')) {
    return { color: 'var(--color-warning)', borderColor: 'var(--color-warning)' };
  }
  if (normalized.includes('crowd') || normalized.includes('exhaust')) {
    return { color: 'var(--color-danger)', borderColor: 'var(--color-danger)' };
  }
  if (normalized.includes('trend') || normalized.includes('structural')) {
    return { color: 'var(--color-success)', borderColor: 'var(--color-success)' };
  }
  return { color: 'var(--color-text)', borderColor: 'var(--color-border)' };
};

const RegimePill: React.FC<RegimePillProps> = ({ label, className }) => {
  return (
    <span
      className={className || ''}
      style={{
        ...getRegimeStyle(label),
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        borderWidth: 1,
        borderStyle: 'solid',
        borderRadius: 999,
        padding: '4px 12px',
        fontSize: '0.7rem',
        fontWeight: 600,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
      }}
    >
      {label}
    </span>
  );
};

export default RegimePill;
